<!--
* @FileDescription: 日期范围选择器
* @Author: chenw
* @Date: 2022-08-09
-->
<template>
  <div class="date-range-container">
    <div class="date-container">
      <el-date-picker
        v-model="startDate"
        :placeholder="startPlaceholder"
        :clearable="clearable"
        :picker-options="startPickerOptions"
      ></el-date-picker>
    </div>
    <div class="separator-container">
      <span>{{ rangeSeparator }}</span>
    </div>
    <div class="date-container">
      <el-date-picker
        v-model="endDate"
        :placeholder="endPlaceholder"
        :clearable="clearable"
        :picker-options="endPickerOptions"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    rangeSeparator: {
      type: String,
      default: "至",
    },
    startPlaceholder: {
      type: String,
      default: "开始日期",
    },
    endPlaceholder: {
      type: String,
      default: "结束日期",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    earlierThanToday: {
      // 是否可以选择比今天更早的日期
      type: Boolean,
      default: true,
    },
  },
  data() {
    // 获取今天0点的时间对象
    const today = new Date(new Date().toLocaleDateString());
    return {
      // 禁用状态
      startPickerOptions: {
        disabledDate: (val) =>
          (!this.earlierThanToday && val < today) ||
          (this.endDate && val > this.endDate),
      },
      endPickerOptions: {
        disabledDate: (val) =>
          (this.startDate && val < this.startDate) ||
          (!this.earlierThanToday && val < today),
      },
    };
  },
  computed: {
    startDate: {
      get() {
        return this.value[0];
      },
      set(v) {
        this.$emit("change", [v, this.endDate]);
      },
    },
    endDate: {
      get() {
        return this.value[1];
      },
      set(v) {
        this.$emit("change", [this.startDate, v]);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.date-range-container {
  display: flex;
  .date-container {
    width: calc(50% - 15px);
    /deep/ .el-date-editor.el-input {
      width: 180px;
    }
  }
  .separator-container {
    width: 30px;
    text-align: center;
  }
}
</style>
